import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'react-bootstrap'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { BsSpeedometer } from "react-icons/bs";

import CustomCheckbox from '../../../component/common/CustomCheckbox'
import { getSpeedEventsFiltersColors, getDurationFormat } from '../../../component/helpers/helperTripsGrid'
import './TripsGrid.sass'

const SpeedEventsDropdown = (posts) => {
	const { t } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar.tripsGrid.speedEventsDropdown' });
	const { speedingEvents, tripsSpeedEventsFilters, setTripsSpeedEventsFilters } = posts
	const ITEMS_ORDER = ['Low Speeding', 'Moderate Speeding', 'High Speeding', 'Severe Speeding']

	const totalDuration = speedingEvents.reduce((previousValue, currentValue) => {
		return previousValue + currentValue.duration
	}, 0)

	const handleSpeedEventsFiltersClick = (e, menuItem) => {
		setTripsSpeedEventsFilters({ ...tripsSpeedEventsFilters, [menuItem]: !tripsSpeedEventsFilters[menuItem] })
	}

	const speedEventsSorted = Object.keys(tripsSpeedEventsFilters).sort((a, b) => ITEMS_ORDER.indexOf(a) - ITEMS_ORDER.indexOf(b))

	return (
		<div>
			{speedingEvents && speedingEvents.length > 0
				&& (
					<Dropdown
						className="alertDropdown"
						id="trip-speed-events-dropdown"
					>
						<Dropdown.Toggle
							className="alertDropdownToggle no-caret"
						>
							<div className="alertBlock">
								<BsSpeedometer className="speedometer-icon" />
								<span className="value">{getDurationFormat(totalDuration)}</span>
							</div>
						</Dropdown.Toggle>
						<Dropdown.Menu className="alertDropdownMenu">
							{speedEventsSorted.map((item) => {
								const event = t(`speedEvents.${item.replace(' ', '')}`)
								return (
									<CustomCheckbox
										key={event}
										checked={tripsSpeedEventsFilters[item]}
										className="primary"
										onChange={(e) => handleSpeedEventsFiltersClick(e, item)}
										color={getSpeedEventsFiltersColors[item]}
										label={t('alert', { item: event })}
										id={event}
									/>
								)
							})}
						</Dropdown.Menu>
					</Dropdown>
				)}
		</div>
	)
}

SpeedEventsDropdown.propTypes = {
	speedingEvents: PropTypes.arrayOf(PropTypes.any).isRequired,
	tripsSpeedEventsFilters: PropTypes.objectOf(PropTypes.any).isRequired,
	setTripsSpeedEventsFilters: PropTypes.func.isRequired,
};

const mapStateToProps = ({ dashboardData }) => ({
	tripsSpeedEventsFilters: dashboardData.tripsSpeedEventsFilters,
});

const mapDispatchToProps = dispatch => ({
	setTripsSpeedEventsFilters: (state) => {
		dispatch({ type: 'SET_TRIPS_SPEED_EVENTS_FILTERS', payload: state })
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(SpeedEventsDropdown);
